import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const services = [
  {
    id: 'bpo', tag: 'BPO', icon: 'fa-headset',
    title: 'Business Process Outsourcing',
    image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80',
    desc: 'End-to-end BPO services designed for scalability and efficiency. Ideal for US, UK, and global clients looking to reduce operational costs while maintaining world-class service quality.',
    highlights: ['Up to 60% cost reduction','24/7 operations capability','English-speaking workforce','Scalable team size'],
    items: [
      { icon: 'fa-phone-alt', title: 'Inbound & Outbound Calls', desc: 'Structured call campaigns, customer follow-ups, payment reminders, and escalation handling with SLA-driven performance.' },
      { icon: 'fa-user-check', title: 'Customer Support', desc: 'Multi-channel support via voice, email, and chat. 24/7 availability for global clients across time zones.' },
      { icon: 'fa-chart-bar', title: 'Sales & Lead Generation', desc: 'Convert prospects into customers with our trained sales agents and proven outreach strategies.' },
      { icon: 'fa-cogs', title: 'Back-Office Operations', desc: 'Data entry, document management, processing, and administrative support with quality control.' },
    ],
  },
  {
    id: 'kpo', tag: 'KPO', icon: 'fa-brain',
    title: 'Knowledge Process Outsourcing',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80',
    desc: 'High-value, insight-driven services requiring specialized domain knowledge. Our KPO team delivers research, analytics, and financial intelligence for data-informed business decisions.',
    highlights: ['Domain expert teams','Actionable intelligence','Compliance-ready reporting','Secure data handling'],
    items: [
      { icon: 'fa-chart-pie', title: 'Data Analytics & Research', desc: 'In-depth analysis, market research, and business intelligence reports tailored to your industry.' },
      { icon: 'fa-file-invoice', title: 'Financial Processing', desc: 'Invoice processing, financial reconciliation, reporting, and compliance support.' },
      { icon: 'fa-lightbulb', title: 'Customer Insights', desc: 'Behavioral data analysis, customer segmentation, and journey mapping for strategic decisions.' },
      { icon: 'fa-clipboard-check', title: 'Reporting & Compliance', desc: 'Regulatory reporting, audit support, and compliance documentation across financial services.' },
    ],
  },
  {
    id: 'hro', tag: 'HRO', icon: 'fa-users-cog',
    title: 'Human Resource Outsourcing',
    image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&q=80',
    desc: 'Complete HR lifecycle management. From sourcing top talent to managing payroll and employee development — we handle your human capital so you can focus on core business.',
    highlights: ['End-to-end HR support','Statutory compliance','Strong talent pipeline','Trained professionals'],
    items: [
      { icon: 'fa-user-plus', title: 'Recruitment & Staffing', desc: 'End-to-end talent acquisition, screening, interviewing, and onboarding aligned with your needs.' },
      { icon: 'fa-money-check-alt', title: 'Payroll Management', desc: 'Accurate, compliant payroll processing with all statutory deductions, PF, ESI filings.' },
      { icon: 'fa-graduation-cap', title: 'Training & Development', desc: 'Skills training, compliance training, and performance development programs for your workforce.' },
      { icon: 'fa-id-card', title: 'HR Administration', desc: 'Employee records, policy management, exit processing, and full HR compliance management.' },
    ],
  },
  {
    id: 'debt', tag: 'DRC', icon: 'fa-file-invoice-dollar',
    title: 'Debt Recovery & Collections',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1200&q=80',
    desc: 'Our legacy strength and core expertise. Professional, ethical, and compliant debt recovery across Karnataka and beyond. Handling personal loans, credit cards, business loans, and NBFC portfolios.',
    highlights: ['Karnataka-wide field network','Ethical & RBI-compliant','95%+ recovery rates','Faster case closure'],
    items: [
      { icon: 'fa-walking', title: 'Field Collections', desc: 'Doorstep recovery with professional, compliant engagement — deep coverage across all Karnataka districts.' },
      { icon: 'fa-search-location', title: 'Skip Tracing', desc: 'Advanced tracking methods and proprietary databases to locate hard-to-reach defaulters efficiently.' },
      { icon: 'fa-handshake', title: 'Negotiation & Resolution', desc: 'Customer-centric recovery strategies that preserve relationships while achieving full settlements.' },
      { icon: 'fa-layer-group', title: 'Multi-Product Recovery', desc: 'Personal loans, credit cards, business loans, and NBFC portfolios — all managed under one expert roof.' },
    ],
  },
];

export default function Services() {
  const [active, setActive] = useState('bpo');
  const current = services.find(s => s.id === active);

  return (
    <div className="services-page">
      <section className="page-hero">
        <div className="ph-grid"></div>
        <div className="ph-photo" style={{backgroundImage:`url('${current.image}')`}}></div>
        <div className="container ph-inner">
          <div className="page-tag">Our Services</div>
          <h1 className="page-h">Outsourcing Solutions<br />Built for <span style={{color:'var(--gold-lt)',fontStyle:'italic'}}>Results</span></h1>
          <p className="page-sub">From debt recovery to global BPO — every service we offer is engineered for measurable outcomes and sustainable growth.</p>
        </div>
      </section>

      <div className="srv-tabs-wrap">
        <div className="container">
          <div className="srv-tabs">
            {services.map(s => (
              <button
                key={s.id}
                className={`srv-tab ${active === s.id ? 'active' : ''}`}
                onClick={() => setActive(s.id)}
              >
                <i className={`fas ${s.icon}`}></i>{s.title}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Service Photo Banner */}
      <div style={{height:'280px',overflow:'hidden',position:'relative'}}>
        <img src={current.image} alt={current.title} style={{width:'100%',height:'100%',objectFit:'cover',transition:'all 0.6s ease'}} />
        <div style={{position:'absolute',inset:0,background:'linear-gradient(to right,rgba(17,29,54,0.75) 0%,transparent 70%)'}}></div>
        <div style={{position:'absolute',left:'64px',bottom:'40px'}}>
          <div style={{fontFamily:'var(--serif)',fontSize:'2.4rem',color:'#fff',fontWeight:300}}>{current.title}</div>
        </div>
      </div>

      <section className="srv-detail-section">
        <div className="container">
          <div className="srv-detail-header">
            <div>
              <div className="srv-detail-tag">{current.tag}</div>
              <h2 className="srv-detail-title">{current.title}</h2>
              <p className="srv-detail-desc">{current.desc}</p>
              <div style={{marginTop:'32px'}}>
                <Link to="/contact" className="btn-navy">
                  <i className="fas fa-arrow-right"></i> Enquire Now
                </Link>
              </div>
            </div>
            <div>
              <div className="srv-highlights-label">Key Highlights</div>
              <div className="srv-highlights">
                {current.highlights.map(h => (
                  <div key={h} className="srv-hl-item">{h}</div>
                ))}
              </div>
            </div>
          </div>

          <div className="srv-items-grid">
            {current.items.map((item, i) => (
              <div key={i} className="srv-item-card">
                <div className="srv-item-icon"><i className={`fas ${item.icon}`}></i></div>
                <h4 className="srv-item-title">{item.title}</h4>
                <p className="srv-item-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section style={{padding:'80px 0',background:'var(--navy-dk)'}}>
        <div className="container" style={{textAlign:'center'}}>
          <h2 style={{fontFamily:'var(--serif)',fontSize:'clamp(1.8rem,3vw,2.4rem)',fontWeight:400,color:'#fff',marginBottom:'16px'}}>
            Ready to Get <span style={{color:'var(--gold-lt)',fontStyle:'italic'}}>Started?</span>
          </h2>
          <p style={{color:'rgba(255,255,255,0.55)',fontSize:'0.9rem',maxWidth:'480px',margin:'0 auto 36px',lineHeight:'1.8'}}>
            Tell us your requirements and we'll have a proposal ready within 48 hours.
          </p>
          <div style={{display:'flex',gap:'16px',justifyContent:'center',flexWrap:'wrap'}}>
            <Link to="/contact" className="btn-gold"><i className="fas fa-paper-plane"></i> Get a Proposal</Link>
            <a href="https://wa.me/919008328891?text=Hello%2C%20I%27d%20like%20to%20know%20more%20about%20your%20services." target="_blank" rel="noreferrer"
              style={{display:'inline-flex',alignItems:'center',gap:'10px',background:'#25D366',color:'#fff',fontFamily:'var(--mono)',fontSize:'0.62rem',letterSpacing:'0.18em',textTransform:'uppercase',padding:'14px 28px',borderRadius:'2px',fontWeight:500,transition:'all 0.3s ease'}}>
              <i className="fab fa-whatsapp" style={{fontSize:'1.1rem'}}></i> WhatsApp Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
